export const GraphSvg = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.08337 3C3.08337 2.58579 2.74759 2.25 2.33337 2.25C1.91916 2.25 1.58337 2.58579 1.58337 3V18.4627C1.58337 18.8769 1.91916 19.2127 2.33337 19.2127H19.7651C20.1793 19.2127 20.5151 18.8769 20.5151 18.4627C20.5151 18.0485 20.1793 17.7127 19.7651 17.7127H3.08337V3ZM19.6031 6.8288C19.8946 6.53449 19.8923 6.05962 19.598 5.76815C19.3037 5.47667 18.8288 5.47897 18.5373 5.77327L13.0855 11.278L9.96935 8.35969C9.67242 8.08161 9.20795 8.09095 8.92244 8.38072L5.04228 12.3188C4.75156 12.6138 4.75508 13.0887 5.05013 13.3794C5.34519 13.6701 5.82005 13.6666 6.11076 13.3716L9.47772 9.95436L12.5925 12.8714C12.8889 13.1489 13.3523 13.1402 13.6381 12.8517L19.6031 6.8288Z"
      fill="currentColor"
    />
  </svg>
);
